import React, { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import "./olympus-glory.scss";

export const OlympusGloryRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  return (
    <>
      <h5 className="card-title">Overview</h5>
      <p className="card-text">
        Olympus Glory is a plinko style game where players drop balls to match symbols and earn rewards!
      </p>
      <p className="card-text">
        There is a bingo card mechanic where to earn a symbol, a ball must enter the symbol pin.
      </p>
      <p className="card-text">
        Match the bingo cards horizontally to earn special rewards!
      </p>
      <img
          className="overview"
          alt="Overview"
          src="/og/overview.png"
        />
      <br/>
      <br/>
      <p className="card-text fw-bold">
        Malfunction voids all win and plays.
      </p>
      <br/>
      <h5 className="card-title">Game Rules</h5>
      <ol className="list-group-numbered p-0">
        <h6 className="card-title">Initial Setup</h6>
        <li className="list-group-item d-flex">
          <div className="ps-3">
            <p className="card-text">
              Enter the lobby. Then, place a bet amount & number of balls to wager.
            </p>
            <p className="card-text">
              Players select between four different rooms with different bet amount. 
            </p>
            <p className="card-text">
              Players select between 5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90 and 100 balls per wager.
            </p>
          </div>
        </li>
        <br/>
        <h6 className="card-title">Gameplay</h6>
        <li className="list-group-item d-flex">
          <p className="card-text ps-3">
              When bets are placed with the (Start) button, the specified number of balls are dropped from the top and cascade down the pegs to the payout tiles below.
          </p>
        </li>
        <br/>
        <li className="list-group-item d-flex">
          <div className="ps-3">
            <p className="card-text">
              The ball strikes one of 2 kinds of payout pins:
            </p>
            <p className="card-text">
              1) A pin with a payout multiplier. The player wins the specified amount stated on the payout tile.
            </p>
            <p className="card-text">
              2) A pin with a symbol. If the symbol matches those on the bingo board on the lower half of the screen, it lights up.
            </p>
            <p className="card-text">
              3) A pin with a skull icon. There is no payout for that ball if it strikes this pin.
            </p>
          </div>
        </li>
        <br/>
        <h6 className="card-title">Bingo Board</h6>
        <li className="list-group-item d-flex">
          <p className="card-text ps-3">
            On the bingo board, if a horizontal line is matched, the player wins the reward stated on the right side of the bingo board. On a win, the binge board refreshes to a new board.
          </p>
        </li>
        <br/>
        <li className="list-group-item d-flex">
          <p className="card-text ps-3">
            On the bingo board, if a horizontal line is matched, the player wins the reward stated on the right side of the bingo board. On a win, the binge board refreshes to a new board.
          </p>
        </li>
        <br/>
        <h6 className="card-title">Autoplay</h6>
        <li className="list-group-item d-flex">
          <p className="card-text ps-3">
            Players may continue betting on more balls or select 'autoplay' for it to place bets for them.
          </p>
        </li>
      </ol>
      <br/>
      <h5 className="card-title">Paytable</h5>
      <h6 className="card-title">Payout Gate</h6>
      <p className="card-text">
        Every gate has its own value.
      </p>
      <p className="card-text">
        There are 3 type of gates in this game:
      </p>
      <table className="table table-bordered table-striped">
        <colgroup>
          <col width="5%" />
          <col width="15%" />
          <col width="50%" />
        </colgroup>
        <thead>
          <tr>
            <th className="text-center">No.</th>
            <th>Gate Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center">1</td>
            <td>Payout Gate</td>
            <td>Player earns a payout similar to what is reflected on the gate.</td>
          </tr>
          <tr>
            <td className="text-center">2</td>
            <td>Symbol Gate</td>
            <td>Player earns a random symbol toward the bingo board.</td>
          </tr>
          <tr>
            <td className="text-center">3</td>
            <td>Skull Gate</td>
            <td>Player does not earn a payout.</td>
          </tr>
        </tbody>
      </table>
      <br/>
      <h6 className="card-title">Bingo Board</h6>
      <p className="card-text">
        Players match symbols against a 3x3 bingo board with symbol icons corresponding to the bonus.
      </p>
      <p className="card-text">
        When the player matches a line with the symbol icons, they earn the bonus as depicted by the board.
      </p>
      <p className="card-text">
        The bingo board is reset after one horizontal line is matched.
      </p>
      <br/>
      <p className="card-text">
        Below is a list of all possible bingo rewards that can appear in the game.
      </p>
      <table className="table table-bordered table-striped ">
        <colgroup>
          <col width="5%" />
          <col width="15%" />
          <col width="50%" />
        </colgroup>
        <thead>
          <tr>
            <th className="text-center">No.</th>
            <th>Reward</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center">1</td>
            <td>Extra Balls 15</td>
            <td>Rains 15 balls down onto the board.</td>
          </tr>
          <tr>
            <td className="text-center">2</td>
            <td>Extra Balls 30</td>
            <td>Rains 30 balls down onto the board.</td>
          </tr>
          <tr>
            <td className="text-center">3</td>
            <td>5x</td>
            <td>Pays out 5x of the ball that completes the symbol icon.</td>
          </tr>
          <tr>
            <td className="text-center">4</td>
            <td>10x</td>
            <td>Pays out 10x of the ball that completes the symbol icon.</td>
          </tr>
          <tr>
            <td className="text-center">5</td>
            <td>20x</td>
            <td>Pays out 20x of the ball that completes the symbol icon.</td>
          </tr>
          <tr>
            <td className="text-center">6</td>
            <td>30x</td>
            <td>Pays out 30x of the ball that completes the symbol icon.</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
